<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1095px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner charge-scheme-batch-dialog"
  >
    <div class="app-main-inner-row">
      <el-form
        label-width="125px"
        label-position="left"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_ProductName')">
              <el-input v-model="form.schemeName" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customer:true}"
                :default-value="form.customer === 0 ? '': form.customer"
                @parentCallBack="p=>form.customer=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_BookingAgent')">
              <cargo-advance-select
                filterable
                options-width="150px;"
                :method-params="{bookingAgent:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="form.bookingAgent === 0 ? '': form.bookingAgent"
                @parentCallBack="p=>form.bookingAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Carrier')">
              <cargo-advance-select
                v-show="isSea"
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :default-value="form.seCarrier === 0 ? '': form.seCarrier"
                @parentCallBack="p=>form.seCarrier=p.cmpIdx"
              />
              <cargo-advance-select
                v-show="!isSea"
                filterable
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true}"
                :default-value="form.aiCarrier === 0 ? '': form.aiCarrier"
                @parentCallBack="p=>form.aiCarrier=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_FLCLType')">
              <el-select
                v-model="form.containerLoadType"
              >
                <el-option
                  v-for="(item,index) in containerLoadTypes"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_CargoType')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="form.cargoType"
                :callback-params="{key:'cargoType'}"
                options-width="150px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('SeaExport.PortOfLoading')">
              <cargo-advance-select
                v-show="isSea"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.txtSeaLoadingPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtSeaLoadingPort=p.code}"
              />

              <cargo-advance-select
                v-show="!isSea"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                options-width="150px;"
                :default-value="form.txtAirLoadingPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtAirLoadingPort=p.code}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
              <cargo-advance-select
                v-show="isSea"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.txtSeaDestinationPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtSeaDestinationPort=p.code}"
              />

              <cargo-advance-select
                v-show="!isSea"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="form.txtAirDestinationPort"
                tag-name="englishName"
                @parentCallBack="p=>{form.txtAirDestinationPort=p.code}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationAgent')">
              <cargo-advance-select
                filterable
                tag-name="englishName"
                options-width="150px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true}"
                :default-value="form.txtDestAgent === 0 ? '': form.txtDestAgent"
                @parentCallBack="p=>form.txtDestAgent=p.cmpIdx"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Airline')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'txtServiceLine'}"
                callback-method-type="value"
                options-width="150px;"
                :default-value="form.txtServiceLine"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('CargoMsg.Cargo_RecordCount')">
              <div style="display: flex;justify-content: space-between">
                <el-input-number
                  v-model="form.limit"
                  :min="10"
                  :max="999"
                  controls-position="right"
                  style="width: 60%;"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="custom"
            >
              <el-button
                type="primary"
                @click="toQuery"
              >{{ $t('common.btn.query') }}</el-button>
              <el-button
                type="primary"
                @click="resetHandler"
              >{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="app-main-inner-row row-grid"
      style="min-height:350px;padding:0"
    >
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :deselect-sub-record="true"
        style="width:100%;height: 400px;"
        @gridReady="onGridReady"
      />
    </div>
    <span
      slot="footer"
      style="padding:10px"
    >
      <el-button
        type="primary"
        @click="selectHandler"
      >{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import ColumnUtils from '@/utils/ColumnUtils'
import { chargeSchemeSelector } from '@/api/costPlan'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { cache } from '@/utils/cacheManager'
import { sortByMultiField } from '@/utils'
import { getLocationList } from '@/api/location'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'

export default {
  name: 'TrackingChargeSchemeBatchDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    selectedList: { type: Array, default: () => [] },
    isSea: { type: Boolean, required: true, default: () => false },
    lob: { type: String, required: true, default: () => '' }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      MAX_COUNT: 5000,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      neverShow: true, // 从未显示过
      chargeWeightValueType: 0, // 录入费用计费数量取值类型
      title: this.$t('SeaExport.BatchFeeScheme'),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.SchemaName'),
          field: 'name',
          width: 200,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: (params) => {
              if (params.data && params.data.parentUuid) {
                return false
              }
              return true
            }
          }
        },
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
          if (this.rowData.length > 0) {
            setTimeout(() => {
              const nodes = this.gridApi.rowModel.rootNode.allLeafChildren
              for (const p of nodes) {
                if (this.selectedList) {
                  const index = this.selectedList.findIndex(pp => pp.uuid === p.key)
                  if (index > -1) {
                    p.selected = true
                  }
                }
              }
              this.gridApi.onGroupExpandedOrCollapsed()
            }, 100)
          }
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowSelected: this.treeDataRowSelectedCallBack
      },
      containerLoadTypes: ContainerLoadType.CONTAINERLOAD_TYPES,
      form: {
        schemeName: '',
        customer: 0,
        bookingAgent: 0,
        seCarrier: 0,
        aiCarrier: 0,
        containerLoadType: '',
        cargoType: '',
        txtSeaLoadingPort: '',
        txtAirLoadingPort: '',
        txtSeaDestinationPort: '',
        txtAirDestinationPort: '',
        txtDestAgent: '',
        txtServiceLine: '',
        limit: 30
      },
      cityList: [], // 城市列表
      rowData: [],
      gridApi: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_PayReceive'),
          field: 'receivable',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PartnerType'),
          field: 'partnerType',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.partnerTypeLabelFunction(params.value)
          },
          width: 140
        },
        {
          headerName: this.$t('SeaExport.Account'),
          field: 'accountId',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.basic_data_Company,
              'cmpIdx',
              Number(params.value),
              'chineseName'
            )
          },
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.MeasureCurrency'),
          field: 'measure',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.measureLabelFunction1(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_RangeAndGE'),
          field: 'rangeGe',
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RangeAndLT'),
          field: 'rangeLt',
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'),
          field: 'eqSize',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.eqSizeLabelFun(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerType'),
          field: 'eqType',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.MeasureUnit'),
          field: 'unitStep',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
          field: 'quantity',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.returnThreeZeroFormatNumber(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice'),
          field: 'unitRate',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.MiniMum'),
          field: 'minimum',
          cellRenderer: (params) => {
            if (params.data['chargeSchemeUuid'] === '') return ''
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax', field: 'unitPriceIncludeTax', width: 120,
          valueFormatter: (params) => {
            if (!params.data['chargeSchemeUuid']) return ''
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', width: 120,
          valueFormatter: (params) => {
            if (!params.data['chargeSchemeUuid']) return ''
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Pricing.BelongingCity'),
          field: 'cityCode',
          width: 120,
          hide: true,
          valueFormatter: (params) => {
            if (!params.value) return ''
            const city = this.cityList.find(p => p.code === params.value)
            if (!city) return ''
            return this.$store.getters.language === 'zh' ? city.chineseName : city.englishName
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remark',
          width: 120
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rowData = []
      }
    },
    innerVisible(newVal) {
      if (newVal) {
        this.initCondition()
      } else {
        // this.rowData = []
        this.$emit('update:visible', newVal)
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = this.visible
      this.initCondition()
    }
  },
  methods: {
    treeDataRowSelectedCallBack(p) {
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    getValueFromChild(obj) {
      // if (!obj || !obj.value) return
      this.form[obj.key] = obj.value
    },
    getCargoType() {
      if (this.lob === 'SE') {
        this.containerLoadTypes = ContainerLoadType.CONTAINERLOAD_TYPES
      } else if (this.lob === 'SI') {
        this.containerLoadTypes = ImportConstants._cargoTypeInputList
      } else if (this.lob === 'AE') {
        this.containerLoadTypes = AirExportConstants.BUSINESS_MODELS
      } else if (this.lob === 'AI') {
        this.containerLoadTypes = ImportConstants._cargoTypeAirInputList
      }
    },
    async getCityList() {
      if (!this.cityList || this.cityList.length <= 0) {
        this.cityList = await getLocationList({}).then((res) => {
          return res.data.list || []
        })
      }
    },
    initCondition() {
      this.chargeWeightValueType = ChargeUtils.getChargeWeightValueType(true)
      this.getCargoType()
      this.title = this.$t('FinanceManage.charge_sp7')
      this.neverShow = false
      this.getCityList()
    },
    toQuery() {
      const map = {}
      map['lob'] = this.lob
      if (this.form.schemeName !== '') {
        map['name'] = this.form.schemeName
      }
      if (this.form.customer > 0) {
        map['customerId'] = this.form.customer
      }
      if (this.isSea) {
        if (this.form.seCarrier > 0) {
          map['carrierId'] = this.form.seCarrier
        }
        if (this.form.txtSeaLoadingPort !== '') {
          map['loadingPort'] = this.form.txtSeaLoadingPort
        }
        if (this.form.txtSeaDestinationPort !== '') {
          map['destinationPort'] = this.form.txtSeaDestinationPort
        }
      } else {
        if (this.form.aiCarrier > 0) {
          map['carrierId'] = this.form.aiCarrier
        }
        if (this.form.txtAirLoadingPort !== '') {
          map['loadingPort'] = this.form.txtAirLoadingPort
        }
        if (this.form.txtAirDestinationPort !== '') {
          map['destinationPort'] = this.form.txtAirDestinationPort
        }
      }
      if (this.form.txtDestAgent > 0) {
        map['destAgent'] = this.form.txtDestAgent
      }
      if (this.form.bookingAgent > 0) {
        map['bookingAgent'] = this.form.bookingAgent
      }
      if (this.form.cargoType !== '' && this.form.cargoType !== 'All') {
        map['cargoType'] = this.form.cargoType
      }
      if (this.form.containerLoadType !== '') {
        map['containerLoadType'] = this.form.containerLoadType
      }
      if (this.form.txtServiceLine !== '') {
        map['region'] = this.form.txtServiceLine
      }
      map['departmentId'] = 0
      if (this.selectedJobs) {
        map['businessDateList'] = Array.from(
          this.selectedJobs,
          (p) => p.businessDate
        )
      }
      map['branchId'] = this.$checkPermission([
        'role_FMChargeScheme_ViewOfficeChargeScheme'
      ])
        ? 0
        : this.$store.getters.currentOfficeId
      map['limit'] = this.form.limit > 0 ? this.form.limit : 30
      map['currentBranchId'] = this.$store.getters.currentOfficeId

      this.loading = getLoading4Cxt(this)
      chargeSchemeSelector(map).then((res) =>
        this.chargeSchemeSelectorResult(res)
      ).finally(() => {
        this.loading.close()
      })
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    chargeSchemeSelectorResult(res) {
      let result = res.data.list
      result = result ? sortByMultiField(result, ['level'], false) : []
      this.setSortData(result, 1)
      // 已经选择的 默认勾选
      if (this.selectedList) {
        this.setSortData(this.selectedList, 0)
        result = result.concat(this.selectedList)
        sortByMultiField(result, ['sort'], false)
        this.rowData = result
      }
      this.rowData = result
    },
    setSortData(list, sort) {
      for (const data of list) {
        data.sort = sort
      }
    },
    selectHandler() {
      const schemeDetails = this.getSelectItems()
      // 调用父组件方法
      this.$emit('selectedSchemeHandler', schemeDetails)
      this.gridApi.deselectAll()
      this.innerVisible = false
    },
    getSelectItems() {
      // 取父级节点
      const rows = this.gridApi.rowModel.rowsToDisplay.filter((node) => { return node.selected })
      const schemeDetails = []
      for (const row of rows) {
        schemeDetails.push(row.data)
      }
      return schemeDetails
    },
    /**
     * 重置条件
     */
    resetHandler() {
      this.form.schemeName = ''
      this.form.customer = 0
      this.form.seCarrier = 0
      this.form.aiCarrier = 0
      this.form.bookingAgent = 0
      this.form.cargoType = ''
      this.form.containerLoadType = ''
      this.form.txtServiceLine = ''
      this.form.containerLoadType = this.containerLoadTypes[0].code // 默认第一个
      this.form.limit = 30
    }
  }
}
</script>
<style lang="scss">
.charge-scheme-batch-dialog {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
  .el-loading-mask {
    z-index: 999999 !important;
  }
}
</style>
